import React, { useState } from 'react';
import { Text } from 'hyarchis-global';
import DocumentGroupRepository from 'services/api-repositories/documentsGroups/DocumentGroupRepository';
import WorkflowRepository from 'services/api-repositories/workflows/WorkflowRepository';
import { DocumentGroup } from 'types/documentGroup';
import Styled from '../drawers.styled';

const { StyledDrawer, StyledButtonText, StyledAddButton, StyledAddDrawerButton, FormGroup } =
  Styled;

interface OwnProps {
  addGroup: (processingJobsGroup: DocumentGroup) => void;
}

const DocumentGroupDrawer = ({ addGroup }: OwnProps) => {
  const [open, setOpen] = useState(false);
  const [processingGroupName, setProcessingGroupName] = useState<string>('');
  const [documentWorkflowId, setDocumentWorkflowId] = useState<string>('');
  const [groupWorkflowId, setGroupWorkflowId] = useState<string>('');

  const addProcessingJobsGroup = async () => {
    const [groupWorkflow, documentWorkflow] = await Promise.all([
      getWorkflow(groupWorkflowId),
      getWorkflow(documentWorkflowId),
    ]);

    const newProcessingJobsGroup = await DocumentGroupRepository.create(
      processingGroupName,
      documentWorkflowId,
    );
    newProcessingJobsGroup.documentWorkflow = documentWorkflow;
    newProcessingJobsGroup.groupWorkflow = groupWorkflow;

    addGroup(newProcessingJobsGroup);
    setOpen(false);
  };

  const getWorkflow = async (workflowId: string | undefined) => {
    if (!workflowId) {
      return undefined;
    }

    return WorkflowRepository.get(workflowId);
  };

  return (
    <>
      <StyledAddDrawerButton type='primary' onClick={() => setOpen(true)}>
        <StyledButtonText>Add group</StyledButtonText>
      </StyledAddDrawerButton>
      <StyledDrawer
        width={700}
        title={<span>Add documents group</span>}
        visible={open}
        closable
        onClose={() => setOpen(false)}
      >
        <FormGroup>
          <Text.Validatable
            required
            label='Documents group name'
            value={processingGroupName}
            onChange={(v) => setProcessingGroupName(v?.toString() || '')}
          />
          <Text.Validatable
            label='Processing job workflow id'
            value={documentWorkflowId}
            onChange={(v) => setDocumentWorkflowId(v?.toString() || '')}
          />
          <Text.Validatable
            label='Group workflow id'
            value={groupWorkflowId}
            onChange={(v) => setGroupWorkflowId(v?.toString() || '')}
          />
          <StyledAddButton type='primary' onClick={() => addProcessingJobsGroup()}>
            Add
          </StyledAddButton>
        </FormGroup>
      </StyledDrawer>
    </>
  );
};

export default DocumentGroupDrawer;
